// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2QghD","form":"styles_form__2ozsp"};